import { fetchAvailableTimes } from 'flux/clients/experiences';
import convertTo24HourFormatObject from 'utils/timeHelpers/convertTo24HourFormatObject';

interface LocalsAvailableForDateTimeProps {
  experienceId: string;
  date: string;
  time: string;
  duration?: number;
  preferredHostId?: string;
}

async function selectAvailableHost({
  experienceId,
  date,
  time,
  preferredHostId,
}: LocalsAvailableForDateTimeProps): Promise<string | null> {
  try {
    const timeObject = convertTo24HourFormatObject(time);
    const formattedTime = `${timeObject.hour}:${timeObject.minute}`;
    const availableTimes = await fetchAvailableTimes({ experienceId, date });

    if (
      preferredHostId &&
      availableTimes?.[preferredHostId]?.includes(formattedTime)
    ) {
      return preferredHostId;
    }

    const alternativeHosts = Object.keys(availableTimes).filter(
      (hostId) =>
        hostId !== preferredHostId &&
        availableTimes?.[hostId]?.includes(formattedTime),
    );

    if (alternativeHosts.length > 0) {
      const randomAlternativeHostId =
        alternativeHosts[Math.floor(Math.random() * alternativeHosts.length)];
      return randomAlternativeHostId;
    } else {
      return preferredHostId || null;
    }
  } catch (error) {
    console.warn('Error fetching available hosts:', error);
    return preferredHostId || null;
  }
}

export default selectAvailableHost;
